import validateEmail from '../util/validate-email';
import Cookies from 'js-cookie';

export default function footer() {
  /**
   * Changing label of footer wpml link
   */
  $('.lang-fr .footer .wpml-ls-menu-item a').text('English');
  $('.lang-en .footer .wpml-ls-menu-item a').text('Français');

  /**
   * Newsletter
   */
  if ($('body > #modal-newsletter').length === 0) {
    $('#modal-newsletter').appendTo('body');
  }

  const $form = $('.footer__form__short form');
  const $email = $form.find('input[type="email"]');

  //Sync email field between forms
  $email.change(function () {
    $('#modal-newsletter').find('input[type="email"]').val($(this).val());
  });

  //Show long form email if is invalid
  const checkEmailInterval = setInterval(function () {
    const $wrapper = $('#modal-newsletter').find('input[type="email"]').closest('.af-field');
    if ($wrapper.hasClass('acf-error')) {
      $wrapper.addClass('visible');
    }
  }, 250);

  //Changing short form placeholder
  $email.focusin(function () {
    $(this).attr('placeholder', $(this).attr('data-placeholder-active'));
  });
  $email.focusout(function () {
    $(this).attr('placeholder', $(this).attr('data-placeholder'));
  });

  //Validate short form and open long form popup
  $form.submit(function (e) {
    e.preventDefault();

    //Quick validation, stop here
    if (!validateEmail($email.val())) {
      $email.addClass('has-error');
    } else {
      $email.removeClass('has-error');
      $('#modal-newsletter').modal();
      $('#modal-newsletter').on('shown.bs.modal', function () {
        $email.val('');
      });
    }
  });
}
